/* eslint-disable @typescript-eslint/no-explicit-any */ var _window_PRELOADED_flags, _window_PRELOADED, // eslint-disable-next-line @stripe-internal/stripe/no-window-preloaded-access
_window;
const getDeprecationMessage = (key, fallback)=>{
    const message = `Sail property "${key}" is deprecated. Please use ${fallback ? `"${fallback}"` : 'native CSS properties'} instead.`;
    return message;
};
export const deprecate = (key, plugin, fallback)=>{
    if (process.env.NODE_ENV !== 'production' || !plugin) {
        return ()=>{
            throw new Error(getDeprecationMessage(key, fallback));
        };
    }
    return plugin;
};
/// Note: The idea is to extend this flag to other properties rather than just height in the future.
export const excludeUndefinedValuesForHeightProp = !!(typeof window !== 'undefined' && ((_window = window) === null || _window === void 0 ? void 0 : (_window_PRELOADED = _window.PRELOADED) === null || _window_PRELOADED === void 0 ? void 0 : (_window_PRELOADED_flags = _window_PRELOADED.flags) === null || _window_PRELOADED_flags === void 0 ? void 0 : _window_PRELOADED_flags.enable_sail_engine_excluded_undefined_values_for_height_prop));

//# sourceMappingURL=utils.js.map